// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19zgA","label":"styles_label__1W23B"};